import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaInstagram, FaFacebook } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* About Section */}
        <div className="footer-section">
          <h3>MyCoachServer</h3>
          <p className="footer-description">
            {t('footer.description')}
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4>{t('footer.quickLinks')}</h4>
          <ul className="footer-links">
            <li><Link to="/">{t('header.home')}</Link></li>
            <li><Link to="/sports">{t('header.sports')}</Link></li>
            <li><Link to="/features">{t('header.features')}</Link></li>
            <li><Link to="/pricing">{t('header.pricing')}</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div className="footer-section">
          <h4>{t('footer.legal')}</h4>
          <ul className="footer-links">
            <li><Link to="/terms">{t('footer.termos')}</Link></li>
            <li><Link to="/privacy-policy">{t('footer.politica')}</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h4>{t('footer.contact')}</h4>
          <ul className="contact-info">
            <li>
              <Link to="/contact" className="footer-contact-link">
                <FaEnvelope />
                <span>{t('footer.contactUs')}</span>
              </Link>
            </li>
            <li className="social-links-container">
              <a
                href="https://www.instagram.com/mycoachserver/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link instagram"
                aria-label="Instagram"
              >
                <FaInstagram />
                <span>Instagram</span>
              </a>
            </li>
            <li className="social-links-container">
              <a
                href="https://www.facebook.com/profile.php?id=61588222416715"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link facebook"
                aria-label="Facebook"
              >
                <FaFacebook />
                <span>Facebook</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>&copy; {currentYear} MyCoachServer. {t('footer.rightsReserved')}</p>
      </div>
    </footer>
  );
};

export default Footer;